import { render, staticRenderFns } from "./filter-common4.vue?vue&type=template&id=c5cd8b88&scoped=true&"
import script from "./filter-common4.vue?vue&type=script&lang=js&"
export * from "./filter-common4.vue?vue&type=script&lang=js&"
import style0 from "./filter-common4.vue?vue&type=style&index=0&id=c5cd8b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cd8b88",
  null
  
)

export default component.exports